import type { UseQueryOptions } from '@tanstack/react-query';

import { scheduledAppsGetCompressorScheduleForecast } from '@repo/sdk/funcs/scheduledAppsGetCompressorScheduleForecast';
import { CompressorScheduleForecast } from '@repo/sdk/models/components';
import { SDKError } from '@repo/sdk/models/errors';
import { GetCompressorScheduleForecastRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { GaiaQueryWithAgentId } from '@/queries/types';

interface GetCompressorScheduleForecastQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
  since: Date;
  until: Date;
}

export const getCompressorScheduleForecastQuery = ({
  agentId,
  client,
  since,
  until,
}: GetCompressorScheduleForecastQueryProps): UseQueryOptions<
  CompressorScheduleForecast,
  SDKError,
  CompressorScheduleForecast | undefined
> => {
  return {
    enabled: !!agentId,
    queryKey: [agentId, 'compressorScheduleForecast', since.toISOString(), until.toISOString()],
    queryFn: () =>
      client<GetCompressorScheduleForecastRequest, CompressorScheduleForecast>({
        gaiaFunc: scheduledAppsGetCompressorScheduleForecast,
        request: {
          agentId: agentId!,
          since,
          until,
        },
      }),
    refetchInterval: 30_000,
    refetchIntervalInBackground: true,
    staleTime: 30_000,
  };
};
